/*
  eslint
  no-param-reassign: ["error", { "props": false }]
*/
export default {
  namespaced: true,
  state: {
    view: 'table',
  },
  mutations: {
    SET_VIEW(state, view) {
      state.view = view;
    },
  },
};
